import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor() { }

  /**
   * Log general - Solo se muestra en desarrollo
   */
  log(message: string, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.log(message, ...optionalParams);
    }
  }

  /**
   * Log de información - Solo se muestra en desarrollo
   */
  info(message: string, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.info(message, ...optionalParams);
    }
  }

  /**
   * Log de advertencia - Solo se muestra en desarrollo
   */
  warn(message: string, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.warn(message, ...optionalParams);
    }
  }

  /**
   * Log de error - Se muestra SIEMPRE (incluso en producción)
   * Los errores son importantes para debugging en producción
   */
  error(message: string, ...optionalParams: any[]): void {
    console.error(message, ...optionalParams);
  }

  /**
   * Log de debug - Solo se muestra en desarrollo
   */
  debug(message: string, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.debug(message, ...optionalParams);
    }
  }

  /**
   * Log de tabla - Solo se muestra en desarrollo
   */
  table(data: any): void {
    if (!environment.production) {
      console.table(data);
    }
  }

  /**
   * Grupo de logs - Solo se muestra en desarrollo
   */
  group(label: string): void {
    if (!environment.production) {
      console.group(label);
    }
  }

  /**
   * Fin de grupo de logs - Solo se muestra en desarrollo
   */
  groupEnd(): void {
    if (!environment.production) {
      console.groupEnd();
    }
  }
}
